module.exports = __webpack_public_path__ + "img/box.5d19ddcc.svg";